var _circle, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 12.5,
    r: 1,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3307 12.725L31.8174 13.1625C31.9073 13.2382 31.9674 13.3439 31.9867 13.4604C32.0061 13.577 31.9835 13.6966 31.923 13.7978L31.3361 14.8097C31.2906 14.8872 31.2256 14.9511 31.1477 14.995C31.0688 15.0391 30.9804 15.0624 30.8903 15.063C30.8344 15.0633 30.7788 15.0549 30.7255 15.038L30.1026 14.8304C29.9935 14.901 29.8801 14.9642 29.7623 15.02L29.6315 15.6575C29.6073 15.7748 29.5426 15.8796 29.449 15.9532C29.3542 16.0281 29.2366 16.0676 29.1163 16.0651H27.9011C27.7807 16.0676 27.6632 16.0281 27.5683 15.9532C27.4749 15.8795 27.4104 15.7747 27.3864 15.6575L27.255 15.02C27.1388 14.9635 27.0261 14.9 26.9174 14.8298L26.2923 15.038C26.239 15.0549 26.1834 15.0633 26.1276 15.063C26.0377 15.0623 25.9494 15.039 25.8708 14.995C25.7929 14.9513 25.7279 14.8875 25.6823 14.8103L25.0745 13.7978C25.0113 13.6957 24.9871 13.5739 25.0065 13.4551C25.026 13.3364 25.0876 13.2289 25.18 13.1527L25.6662 12.5326V12.3402L25.1794 11.9027C25.0896 11.827 25.0295 11.7213 25.0102 11.6048C24.9908 11.4883 25.0134 11.3686 25.0739 11.2674L25.6818 10.2555C25.7273 10.178 25.7923 10.1141 25.8702 10.0702C25.9489 10.0263 26.0372 10.0029 26.127 10.0023C26.1824 9.99873 26.238 10.0039 26.2918 10.0175L26.9045 10.2349C27.014 10.1642 27.1274 10.101 27.2448 10.0452L27.3761 9.40771C27.4002 9.29052 27.4647 9.18576 27.5581 9.11207C27.6529 9.03715 27.7705 8.9976 27.8908 9.00011H29.0958C29.2162 8.9976 29.3337 9.03715 29.4285 9.11207C29.5227 9.18652 29.5874 9.29141 29.6105 9.40771L29.7419 10.0452C29.8585 10.1013 29.9711 10.1648 30.0795 10.2354L30.7051 10.0278C30.7745 10.005 30.8479 9.99699 30.9205 10.0043C30.9932 10.0116 31.0636 10.034 31.1272 10.0702C31.2053 10.1148 31.2699 10.1789 31.3156 10.255L31.923 11.2674C31.987 11.3686 32.0124 11.4899 31.9943 11.6086C31.9763 11.7273 31.9161 11.8353 31.825 11.9125L31.3307 12.3375V12.725Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 20.5,
    width: 8,
    height: 2,
    rx: 1,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22V22C32 23.1046 31.1046 24 30 24H27C25.8954 24 25 23.1046 25 22V22",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3452 20.6484C25.2215 19.9534 24.5203 18.6395 22.8707 16.2754C20.9654 13.545 21.8808 5.64844 28.624 5.64844M31.6509 20.6484C31.7746 19.9534 32.4758 18.6395 34.1254 16.2754C36.0306 13.545 35.1153 5.64844 28.3721 5.64844",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.998 5.64844L21.998 4.64844",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6414 11.5008H18.9992",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9989 11.5008H36.3566",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4992 3.64145V1.99918",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.998 5.64844L34.998 4.64844",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 28,
    rx: 1.5,
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 12.5,
    x2: 16.5,
    y2: 12.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 6.5,
    x2: 17.5,
    y2: 6.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 18.5,
    x2: 19.5,
    y2: 18.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 25.5,
    x2: 35.5,
    y2: 25.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 15.5,
    x2: 17.5,
    y2: 15.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 21.5,
    x2: 21.5,
    y2: 21.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 4,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaContentIcon);
export default __webpack_public_path__ + "static/media/socialMediaContentIcon.11b59a6d9a86ea51198c5a5ee3e66ab7.svg";
export { ForwardRef as ReactComponent };